import graphql from "babel-plugin-relay/macro";

const CheckOrderStatusQuery = graphql`
query CheckOrderStatusQuery($id:ID){
   allOrders(id:$id){
    edges{
      node{
        orderStatus
      }
    }
  }
}
`

export default CheckOrderStatusQuery;